import { z } from 'zod'

export const CursorPaginationSchema = <ItemSchema extends z.ZodType>(
  schema: ItemSchema
) =>
  z.object({
    items: z.array(schema),
    next: z.string().optional(),
    prev: z.string().optional(),
  })
